import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Banner from '../UI/Banner'
import useCurrentSubscription from '../../services/subscription/useCurrentSubscription'

/**
 * The plan-change notice above Plan & Billing. The unactivated-account banner
 * that used to share this component now lives in the layout, so it travels
 * with the user instead of only appearing on the page they were redirected to
 * - see `LimitedModeBanner`.
 */
const PlanBanners = () => {
  const { t } = useTranslation()
  const { data: subscription } = useCurrentSubscription()
  const [isPlanUpdateDismissed, setIsPlanUpdateDismissed] = useState(false)

  const hasPendingPlanChange = Boolean(subscription?.pending_plan_change)

  if (!hasPendingPlanChange || isPlanUpdateDismissed) return null

  return (
    <Banner
      variant='dismissible'
      className='-mx-5 md:-mx-7 lg:-mx-9 -mt-5 mb-5'
      text={t('planUpdateNotActiveBanner')}
      onDismiss={() => setIsPlanUpdateDismissed(true)}
    />
  )
}

export default PlanBanners
